module.exports = __webpack_public_path__ + "static/media/icon8.2034dd91.png";